export default {
    confirmMessageLaceTop:
        'בחירה בלייס טופ תמחק את כל המידע שהוזן בסעיף "פרונט". האם את בטוחה שאת רוצה להמשיך?',
    confirmMessageRibben:
        'בחירה ריבן תמחק את כל המידע שהוזן בסעיף "פרונט". האם את בטוחה שאת רוצה להמשיך?',
    confirmMessageKosherTop:
        'האפשרות "פרונט" כבר מולאה. בחירה ב"טופ כשר" תנקה ותשבית את האפשרות "סוג טופ". האם את בטוחה שברצונך להמשיך?'
}
